import { MasterDocument } from '@util/firestore/master';
import { trackMasterEvent } from '@util/analytics/masterTracking';

interface FAQSectionProps {
  master: MasterDocument;
}

export default function FAQSection({ master }: FAQSectionProps) {
  if (!master.gmFaq || master.gmFaq.length === 0) {
    return null;
  }

  return (
    <section id="faq" aria-label="Frequently Asked Questions">
      <div className="max-w-default mx-auto px-[2rem] md:px-[4rem] xl:px-default-padding-x py-[3rem]">
        <h2 className="text-[2.4rem] sm:text-[3.2rem] font-extrabold text-black mb-[2rem]">
          Frequently Asked Questions<span className="sr-only"> — {master.brand} {master.model}</span>
        </h2>
        <div className="space-y-[1.6rem]">
          {master.gmFaq.map((faq, index) => (
            <details
              key={index}
              className="group bg-white border border-black rounded-[0.6rem] overflow-hidden"
              onToggle={(e) => {
                if ((e.currentTarget as HTMLDetailsElement).open) {
                  trackMasterEvent('master_faq_expand', master, {
                    section: 'faq',
                    faq_question: faq.question,
                  });
                }
              }}
            >
              <summary className="cursor-pointer px-[2.4rem] py-[2rem] text-[1.8rem] font-bold text-brand-dark-gray hover:bg-gray-50 list-none flex items-center justify-between">
                <span>{faq.question}</span>
                <span className="text-gray-400 ml-[1rem] shrink-0 transition-transform group-open:rotate-45">
                  +
                </span>
              </summary>
              <div
                className="px-[2.4rem] py-[2rem] text-[1.6rem] leading-[2.6rem] text-gray-600 border-t border-gray-200 [&_a]:text-brand-secondary [&_a]:underline [&_a:hover]:text-brand-orange"
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              />
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
